import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import {   } from '../../Icons/Icons';
import RadioButtonChecked from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUnchecked from '@material-ui/icons/RadioButtonUnchecked';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';

import './Test.css';

class DGRTest extends Component {
    componentDidMount(){
        this.props.DGRBackgroundStore.showBlurAndHeader()
    }

    render(){
        return (
            <ExpansionPanel>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            Product Type
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
            <div className="cardTest">
                <div className="productCard">
                    <div className="imgCard">
                        <div className="fullImg">
                            <img alt='' src="/static/img/ahmad1.jpg"/>  
                        </div>
                    </div>
                    <div className="pricingSide">
                        <div className="pricingCard">
                           <div className="feature">
                                <span className="title">
                                    Sport Level 
                                </span>
                                <div className="options">
                                    <div className="option">
                                        <RadioButtonChecked className="check"/>
                                        No Commitment
                                    </div>
                                    <div className="option">
                                        <RadioButtonUnchecked className="uncheck"/>
                                        Reduced Dues
                                    </div>
                                    <div className="option">
                                        <RadioButtonUnchecked className="uncheck"/>
                                        Lower Initiation
                                    </div>
                                </div>
                                <div className="bylines">
                                    <div>
                                        12 month commitment required. 
                                    </div> 
                                    <div>
                                        Prices do not include sales tax.
                                    </div> 
                                    <div>
                                        See membership details 
                                    </div> 
                                </div>
                            </div>
                           <div className="pricing">
                                <div className="price">
                                29.99 
                                </div>
                                <div className="monthlyDues">
                                    Monthly Dues 
                                </div>
                                <div className="initiation">
                                    Initiation: $29.99
                                </div>
                                <div className="annualFee">
                                    Annual Fee: $29.99
                                </div>
                                <div className="dueToday">
                                    Due Today: $29.99
                                </div>
                                <button className="bigButton">Select > </button>

                           </div>
                        </div> 
                    </div> 
                </div>
            </div>
            </ExpansionPanelDetails>
            </ExpansionPanel>
        )
    }
}

DGRTest  = inject('DGRBackgroundStore')(observer(DGRTest ))     
export default DGRTest  ;


/*
 *
 */



// WEBPACK FOOTER //
// ./src/components/DGR/Test/Test.js